module.exports = __webpack_public_path__ + "img/lock.b86753b8.svg";